import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        review: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'performanceReview' | translate}}</h2>
        </div>
        <div class="modal-body">
            <alert-error ng-if="vm.error">{{ vm.error }}</alert-error>
            <div class="alert alert-plain">
                <p>{{ 'performanceReview.Confirm.Alert' | translate }}</p>
            </div>
            <div class="form">
                <div class="row">
                    <label class="label">{{ 'general.Comment' | translate }}</label>
                    <div class="items">
                        <textarea
                            class="form-control fixed"
                            ng-model="vm.form.model.employeeConfirmComment">
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.confirm()">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})

export default class {
    constructor ($translate, $rootScope, ReviewResource, ReviewService, FormFactory, REVIEW_STATUS_ENUM) {
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.ReviewResource = ReviewResource;
        this.ReviewService = ReviewService;
        this.FormFactory = FormFactory;
        this.REVIEW_STATUS_ENUM = REVIEW_STATUS_ENUM;
    }

    $onInit () {
        const expand = this.ReviewService.getExpandString();
        this.error = false;
        this.form = this.FormFactory.create(
            this.review,
            model => this.ReviewResource.publicUpdate({ guid: model.guid, expand }, model).$promise
        );
    }

    confirm () {
        this.form.model.status = this.REVIEW_STATUS_ENUM.KEYS.CONFIRMED;
        this.form.save()
            .then(() => {
                this.$rootScope.$broadcast('review:confirm:success', true);
                this.uibModalInstance.close();
            })
            .catch(() => {
                this.error = this.form.errors.employeeConfirmComment;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/review/confirm/index.js